query ReadParameterGroup(
    $id: ID!
) {
    parameterGroup(id: $id) {
        name {
            language
            text
        }
        order
        tier
    }
}
